<nav class="freida-navigation" [ngClass]="{ 'scrolled': isScrolled }"
     role="navigation"
     (click)="onNavClick()"
     *ngxObserve="currentUser$ as user;">
  <div class="freida-navigation__content">
    <div class="freida-navigation__content__mobile-menu"
         role="button"
         tabindex="0"
         aria-label="Toggle navigation menu"
         (click)="toggleMenu('trigger')"
         (keydown.enter)="toggleMenu('trigger')"></div>

    <div class="freida-navigation__content__menus"
         data-test="freida-navigation">
      <div class="freida-navigation__content__menu">
        <a href="/specialty"
          class="freida-navigation__content__menu__title"
          (click)="navigateTo('/specialty', $event);">
          <span>Explore Specialties</span>
        </a>
      </div>
      <div class="freida-navigation__content__menu">
        <a class="freida-navigation__content__menu__title tr-title"
           href="javascript:void(0)"
           tabindex="0"
           role="button"
           [attr.aria-expanded]="showToolsResourcesMenu"
           (keydown.enter)="toggleToolsResourcesMenu()"
           (click)="toggleToolsResourcesMenu()"
           [attr.aria-label]="showToolsResourcesMenu ? 'Tools & Resources menu open press enter to close' : 'Tools & Resources menu closed press enter to open'">
           <span>Tools & Resources</span>
              @if (showToolsResourcesMenu) {
                <i class="ph ph-caret-up"></i>
              }
              @else {
                <i class="ph ph-caret-down"></i>
              }

          </a>

        @if (showToolsResourcesMenu) {
          <div class="freida-navigation__content__menu submenu">

            <a class="freida-navigation__content__menu__title" href="/video-series"
              (click)="navigateTo('/video-series', $event);"
              routerLinkActive="active"
              >
              <span>Video Gallery</span>
            </a>
            <a class="freida-navigation__content__menu__title" href="/road-to-residency-guide"
              (click)="navigateTo('/road-to-residency-guide', $event);"
              routerLinkActive="active">
              <span>Prep for Residency</span>
            </a>
            <a class="freida-navigation__content__menu__title" href="/calculator"
              (click)="navigateTo('/calculator', $event);"
               [ngClass]="{'disabled': disableUpdates$()}"
              routerLinkActive="active">
              <span>Residency Calculator</span>
            </a>
            <a class="freida-navigation__content__menu__title"
               href="/residency-alignment?retake=true"
               [ngClass]="{'disabled': disableUpdates$()}"
               (click)="navigateTo('/residency-alignment?retake=true', $event);"
               routerLinkActive="active">
               <span>OBGYN ACI</span>
            </a>
            <a class="freida-navigation__content__menu__title" href="/contact"
              (click)="navigateTo('/contact', $event);"
              routerLinkActive="active">
              <span>Contact FREIDA</span>
            </a>
            <a class="freida-navigation__content__menu__title" href="/faq"
              (click)="navigateTo('/faq', $event);"
              routerLinkActive="active">
              <span>FAQ</span>
            </a>
          </div>
        }
      </div>
      <div class="freida-navigation__content__menu">
        <a href="/vacant-position/list" (click)="navigateTo('/vacant-position/list', $event);" class="freida-navigation__content__menu__title">
          <span>Vacant Positions</span>
        </a>
      </div>
      <div class="freida-navigation__content__menu">
        <a href="/institution?page=1" (click)="navigateTo('/institution?page=1', $event);" class="freida-navigation__content__menu__title">
          <span>Institution Directory</span>
        </a>
      </div>
        <div class="freida-navigation__content__menu" (keydown.tab)="focusOnElementFFException()" (keydown.enter)="goToProgramDirectorPortal(user, $event)" tabindex="0">
          <a  id="programDirectorPortalLink" #programDirectorPortalLink  class="freida-navigation__content__menu__title" tabindex="0"
          href="/director"
          [ngClass]="{'disabled': disableUpdates$()}"
          (click)="goToProgramDirectorPortal(user, $event)" >
          <span>Program Director Portal</span>
        </a>
      </div>
    </div>
    <!-- Dashboard Button -->
    @if (user?.roles?.includes('authenticated')) {
    <div class="freida-navigation__content__button__container desktop">
      <div class="freida-navigation__content__button__container"
           id="navigationDashboardButton"
           #navigationDashboardButton
           tabindex="0">
        <app-button
          [disabled]="disableUpdates$()"
          label="Dashboard"
          variant="primary"
          icon="bookmark-simple"
          (clicked)="goToDashboard()"
          ariaLabel="Go to dashboard"
        />
      </div>
    </div>
    }
  </div>
</nav>
